/* ============================================================
   Líder — Carrinho lateral (drawer)
   Abre/fecha, altera quantidade e remove itens. Após cada mudança,
   re-renderiza a section pelo servidor (Section Rendering API), então
   subtotal, barra de frete e contagem se atualizam sozinhos.
   ============================================================ */
(function () {
  'use strict';

  var SECTION = 'lider-cart-drawer';
  var root, panel;

  function el() {
    root = document.querySelector('[data-lider-cd]');
    panel = root ? root.querySelector('.lider-cd__panel') : null;
    return !!root;
  }

  function sectionId() {
    return (root && root.dataset.sectionId) || SECTION;
  }

  function open() {
    if (!root && !el()) return;
    root.hidden = false;
    void root.offsetWidth;
    root.classList.add('is-open');
    document.documentElement.style.overflow = 'hidden';
  }

  function close() {
    if (!root) return;
    root.classList.remove('is-open');
    document.documentElement.style.overflow = '';
    setTimeout(function () { if (root) root.hidden = true; }, 320);
  }

  function busy(on) {
    if (root) root.classList.toggle('is-busy', !!on);
  }

  function refresh() {
    if (!root) return Promise.resolve();
    var sid = sectionId();
    return fetch(window.location.pathname + '?sections=' + encodeURIComponent(sid))
      .then(function (r) { return r.json(); })
      .then(function (sections) {
        var html = sections[sid];
        if (!html) return;
        var tpl = document.createElement('div');
        tpl.innerHTML = html;
        var fresh = tpl.querySelector('.lider-cd__panel');
        if (fresh && panel) panel.innerHTML = fresh.innerHTML;
      })
      .catch(function () {});
  }

  function refreshBubble() {
    return fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (c) {
        document.querySelectorAll('[data-lider-cart-count]').forEach(function (b) {
          b.textContent = c.item_count < 100 ? c.item_count : '99';
          b.hidden = c.item_count === 0;
        });
      })
      .catch(function () {});
  }

  function afterChange() {
    return Promise.all([refresh(), refreshBubble()]).then(function () { busy(false); });
  }

  function changeLine(line, quantity) {
    busy(true);
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: parseInt(line, 10), quantity: quantity })
    })
      .then(function (r) { return r.json(); })
      .then(afterChange)
      .catch(function () { busy(false); });
  }

  function bind() {
    if (!el()) return;

    root.addEventListener('click', function (e) {
      if (e.target.closest('[data-lider-cd-close]')) { e.preventDefault(); close(); return; }

      var removeBtn = e.target.closest('[data-lider-cd-remove]');
      if (removeBtn) { e.preventDefault(); changeLine(removeBtn.getAttribute('data-lider-cd-remove'), 0); return; }

      var qtyBtn = e.target.closest('[data-lider-cd-qty]');
      if (qtyBtn && !qtyBtn.disabled) {
        e.preventDefault();
        var to = parseInt(qtyBtn.dataset.to, 10);
        if (to >= 0) changeLine(qtyBtn.getAttribute('data-lider-cd-qty'), to);
        return;
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && root && !root.hidden) close();
    });

    // qualquer gatilho de carrinho no header abre o drawer
    document.addEventListener('click', function (e) {
      var trigger = e.target.closest('[data-lider-cart-open]');
      if (!trigger) return;
      e.preventDefault();
      open();
      refresh();
    });
  }

  window.LiderCart = {
    open: function () { open(); },
    close: close,
    refresh: refresh,
    openRefreshed: function () { open(); return afterChange(); }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind);
  } else {
    bind();
  }
})();
